import React from "react";
import PersonView from "../PersonView";

interface PersonListRendererProps
{
    value: Person[];
    admins?: boolean;
}

export default class PersonListRenderer extends React.Component<PersonListRendererProps>
{
    render(): React.ReactNode
    {
        if (!this.props.value || !Object.keys(this.props.value).length)
            return <div><b> - </b></div>;

        //Filter duplicate names
        let people = Array.from(new Set(this.props.value.map(a => a.fullName)))
            .map(name =>
            {
                return this.props.value.find(a => a.fullName === name)
            });

        return people.map((person, i) =>
        {
            return <div key={i}><PersonView admins={this.props.admins} data={person} /></div>;
        });
    }
}